import { createEntityAdapter } from '@reduxjs/toolkit';
import { IUser, IPersonalInfo } from '@tacans/shared-marketplace-layer';

export const ProfileAdapter = createEntityAdapter<{
    user: IUser;
    personalInfo: IPersonalInfo;
}>({
    selectId: (data) => data.user.login,
});
